export default __webpack_public_path__ + "static/media/loading.fdf1cf61.png";